import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AnalyticsMarker } from 'src/components/AnalyticsMarker/AnalyticsMarker';

/** Explains that the list was opened from an analytics figure; ✕ returns to the unfiltered list. */
export const AnalyticsSourceChip = ({
    filterLabel,
    month,
    onClear,
    analyticsHref,
}: {
    filterLabel: string;
    month?: string;
    onClear: () => void;
    /** The organization's Analytics page, when the viewer can open it. */
    analyticsHref?: string;
}) => {
    const { t, i18n } = useTranslation();
    const monthLabel = month
        ? new Date(`${month}-15T12:00:00Z`).toLocaleDateString(i18n.language, {
              month: 'short',
              year: 'numeric',
          })
        : undefined;
    return (
        <div className="inline-flex max-w-full items-center gap-2 self-start rounded-full border border-woodyBrown/10 bg-white py-1 pl-1.5 pr-1 text-sm text-woodyBrown">
            <AnalyticsMarker
                hint={t('modules.messages.filters.analyticsHint')}
            />
            {analyticsHref ? (
                <Link
                    to={analyticsHref}
                    className="min-w-0 truncate underline-offset-2 hover:underline"
                >
                    {[
                        t('modules.messages.filters.fromAnalytics'),
                        filterLabel,
                        monthLabel,
                    ]
                        .filter(Boolean)
                        .join(' · ')}
                </Link>
            ) : (
                <span className="min-w-0 truncate">
                    {[
                        t('modules.messages.filters.fromAnalytics'),
                        filterLabel,
                        monthLabel,
                    ]
                        .filter(Boolean)
                        .join(' · ')}
                </span>
            )}
            <button
                type="button"
                className="inline-flex h-6 w-6 items-center justify-center rounded-full hover:bg-woodyBrown/10"
                onClick={onClear}
                aria-label={t('modules.messages.filters.clearAnalytics')}
            >
                <X size={14} aria-hidden="true" />
            </button>
        </div>
    );
};
